// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export { stringifyXML, parseXML } from "./xml.js";
export { XML_ATTRKEY, XML_CHARKEY, XmlOptions } from "./xml.common.js";
